import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './DocumentActionType';
import * as actions from './DocumentActions';
import * as commonService from './DocumentServices';

function* fetchDocumentsSaga(action) {
    try {
        const response = yield call(commonService.getDocuments, action.payload);
        yield put(actions.getDocumentsSuccess(response?.data || {}));
    } catch (error) {
        yield put(actions.getDocumentsFailure(error));
    }
}

export default function* watchDocumentSaga() {
    yield takeLatest(types.GET_DOCUMNETS_REQUEST, fetchDocumentsSaga);
}